import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Icon, Link } from '@honda-canada/design-system-react';
import React, { useContext, useEffect } from 'react';
import { UserLocationContext } from '@honda-canada/user-location';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { useProvinces, useSettings } from '../../../utils/sitecoreContext';
import SpecialOffersContext from '../SpecialOffersContext';
import themeStyles from '../styles/LoyaltyOfferFilters.styles';
import { variant1 } from '../constants';
const Container = themeStyles.apply(Box, 'UserLocationContainer');
const ChangeLocationButton = themeStyles.apply(Link, 'ChangeLocationButton');
const ButtonWrapper = themeStyles.apply(Box, 'ButtonWrapper');
const variantIconStyleRecord = {
    [variant1]: { filled: true },
};
const GeoLocatorSummary = ({ onChangeLocationClick, addressSelectedByUser }) => {
    var _a, _b, _c, _d, _e;
    const userLocation = useContext(UserLocationContext);
    const { defaultProvince } = useSettings();
    const { variant } = useContext(SpecialOffersContext);
    const { sitecoreContext } = useSitecoreContext();
    const provinces = useProvinces();
    const defaultProvinceName = defaultProvince && ((_a = provinces.find(p => p.name === defaultProvince)) === null || _a === void 0 ? void 0 : _a.displayName);
    const requestLocation = (_c = (_b = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.route) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.requestLocation;
    useEffect(() => {
        if ((requestLocation === null || requestLocation === void 0 ? void 0 : requestLocation.value) && !addressSelectedByUser) {
            onChangeLocationClick(true);
        }
        else {
            onChangeLocationClick(false);
        }
    }, [requestLocation === null || requestLocation === void 0 ? void 0 : requestLocation.value, addressSelectedByUser]);
    const btnLabel = userLocation.addressSelectedByUser ? userLocation.provinceName : defaultProvinceName;
    const hasFilledIcons = (_e = (_d = variantIconStyleRecord[variant]) === null || _d === void 0 ? void 0 : _d.filled) !== null && _e !== void 0 ? _e : false;
    return (_jsx(Container, { children: _jsxs(ButtonWrapper, { children: [_jsx(ChangeLocationButton, { as: "button", styling: "tertiaryLight", "data-testid": "geo-location-change-button", "aria-label": "Change Location", onClick: (e) => {
                        e.stopPropagation();
                        if (onChangeLocationClick) {
                            onChangeLocationClick(true);
                        }
                    }, children: btnLabel }), _jsx(Icon, { filled: hasFilledIcons, name: "edit", ml: "xxs", mb: "0.5ch", iconColor: "tertiaryLight" })] }) }));
};
export default GeoLocatorSummary;
